// 卫生安全通知
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'

export default (state) => {
  let health = get(state, 'currentShopBaseDetail.docInfo.health', {})
  return {
    title: i18n.gettext('卫生安全通知'),
    content: [
      // {
      //   title: i18n.gettext('餐厅名称'),
      //   label: health.resName
      // },
      // {
      //   title: i18n.gettext('餐厅地址'),
      //   label: health.resAddr
      // },
      // {
      //   title: i18n.gettext('许可证编号'),
      //   label: health.licenseNum
      // },
      // {
      //   title: i18n.gettext('经营范围'),
      //   label: health.scope
      // },
      // {
      //   title: i18n.gettext('有效期'),
      //   content: health.validateDate
      // },
      {
        title: i18n.gettext('执照照片'),
        content: i18n.gettext('查看'),
        isLink: true,
        arrow: true,
        pics: health.licensePics
      }
    ]
  }
}
